import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../utils/axios";
import { useNavigate } from "react-router-dom";
import { AgentcheckTokenValidity } from "../utils/AgentTokenValidity";
import Config from "../utils/config";

const AgentLogin = ({ title, description, redirectRoute }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkIfLoggedIn = async () => {
      const isLoggedIn = await AgentcheckTokenValidity();
      if (isLoggedIn) {
        navigate(redirectRoute);
      }
    };

    checkIfLoggedIn();
  }, [navigate, redirectRoute]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);

    axios
      .post(`${Config.baseURL}/agent-login`, {
        email: email,
        password: password,
      })
      .then((response) => {
        setIsLoading(false);

        const { token, firstName, lastName, matricules, email, poste } =
          response.data;

        localStorage.setItem("token-agent", token);
        localStorage.setItem("firstName", firstName);
        localStorage.setItem("lastName", lastName);
        localStorage.setItem("matricules", matricules);
        localStorage.setItem("email", email);
        localStorage.setItem("poste", poste);

        toast.success("Connecté avec succès !");
        navigate(redirectRoute);
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error("Nom d'utilisateur ou mot de passe incorrect");
      });
  };

  return (
    <div className="max-w-7xl min-w-full sm:min-w-[30%] mx-auto p-6 mt-12 rounded sm:shadow-xl shadow-slate-200">
      <h1 className="text-3xl sm:text-4xl text-center font-medium text-indigo-900">
        {title}
      </h1>
      <p className="text-center mt-4 text-gray-600">{description}</p>
      <img
        src="/logo.png"
        width={150}
        height={150}
        alt="Recruitment Form"
        className="mt-6 mx-auto"
      />
      <form onSubmit={handleSubmit} className="my-10">
        <div className="flex flex-col space-y-8">
          <label htmlFor="email">
            <p className="font-medium text-slate-700 pb-2">Adresse e-mail</p>
            <input
              id="email"
              name="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full py-3 border border-slate-200 rounded-lg px-3 focus:outline-none focus:border-slate-500 hover:shadow"
              placeholder="Entrez votre adresse e-mail"
              required
            />
          </label>
          <label htmlFor="password">
            <p className="font-medium text-slate-700 pb-2">Mot de passe</p>
            <input
              id="password"
              name="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full py-3 border border-slate-200 rounded-lg px-3 focus:outline-none focus:border-slate-500 hover:shadow"
              placeholder="Entrez votre mot de passe"
              required
            />
          </label>
          <button
            className="w-full py-3 font-medium text-white bg-indigo-600 hover:bg-indigo-500 rounded-lg border-indigo-500 hover:shadow inline-flex space-x-2 items-center justify-center"
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 animate-spin"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 2v2m0 16v2m8.485-9.485h-2M4.515 12H2m16.97 5.485l-1.414-1.414M7.05 7.05L5.636 5.636m12.727 12.728l-1.414-1.414M7.05 16.95l-1.414 1.414"
                  />
                </svg>
                <span>Connexion en cours...</span>
              </>
            ) : (
              <>
                <span>Connexion</span>
              </>
            )}
          </button>
        </div>
      </form>
      <ToastContainer />
    </div>
  );
};

export default AgentLogin;
